export function getEnvName() {
  const hostName = window.location.hostname;

  switch(hostName) {
    case "localhost":
    case "[::1]":
      return "local";

    case "eitcg-dev-int.cdxms.devl-etss.aws.fanniemae.com":
    case "eitcg.cdxms.devl-etss.aws.fanniemae.com":
    case "webapp-essui-eb.eitcg.devl-ess.aws.fanniemae.com":
    case "cgo-ui-dev-01-eb.eitcg.devl-sfbu.aws.fanniemae.com":
    case "ess-ui-devl-eb.eitcg.devl-ess.aws.fanniemae.com":
    case "gfy.eitcg.sfbu.devl.intgfanniemae.com": // external
      return "devl";

    case "eitcg.cdxms.test-etss.aws.fanniemae.com":
    case "gfy.eitcg.sfbu.test.intgfanniemae.com": // external
      return "test";

    case "eitcg-sfbu.cdxms.acpt-etss.aws.fanniemae.com":
    case "eitcg.cdxms.acpt-etss.aws.fanniemae.com":
    case "gfy.eitcg.sfbu.acpt.intgfanniemae.com": // external
      return "acpt";

    case "eitcg.cdxms.clve-etss.aws.fanniemae.com":
    case "gfy.eitcg.sfbu.clve.fanniemae.com": // external
      return "clve";

    case "eitcg.cdxms.prod-etss.aws.fanniemae.com":
    case "condo.fanniemae.com": // external
      return "prod";
  }

  if (/\bacpt\b/.test(window.location.hostname)) {
    return "acpt";
  }

  return "prod";
}

export const ReportByEnviroment = {
    lowerEnv: {
        psReports: [
            {
                title: "Unavailable Projects & Phases",
                body: "All projects and phases where Fannie Mae has applied a status of  Unavailable",
            },
            {
                title: "Approved Projects & Phases",
                body: "All projects and phases where Fannie Mae has applied a status of  Approved",
            },
            {
                title: "All Projects & Phases",
                body: "All projects and phases entered in the system",
            },
            {
                title: "Lender Certification Activity",
                body: "All certification data, including lender details and certification status, on any project or phase with a saved certification in the new CPM 2.0 platform.",
            },
            {
                title: "Lender Certification Details",
                body: "Lender specific responses on saved certifications",
            },
        ],
        lenderReports: [
            {
                title: "Lender Certification Activity",
                body: "All certification data, including lender details and certification status, on any project or phase with a saved certification in the new CPM 2.0 platform.",
            },
        ],
        tpoReports: [
            {
                title: "Lender Certification Activity",
                body: "All certification data, including lender details and certification status, on any project or phase with a saved certification in the new CPM 2.0 platform.",
            },
        ]
    },
    higherEnv: {
        psReports: [
            {
                title: "Unavailable Projects & Phases",
                body: "All projects and phases where Fannie Mae has applied a status of  Unavailable",
            },
            {
                title: "Approved Projects & Phases",
                body: "All projects and phases where Fannie Mae has applied a status of  Approved",
            },
            {
                title: "All Projects & Phases",
                body: "All projects and phases entered in the system",
            },
            {
                title: "Lender Certification Activity",
                body: "All certification data, including lender details and certification status, on any project or phase with a saved certification in the new CPM 2.0 platform.",
            },
            {
                title: "Lender Certification Details",
                body: "Lender specific responses on saved certifications",
            },
        ],
        lenderReports: [
            {
                title: "Lender Certification Activity",
                body: "All certification data, including lender details and certification status, on any project or phase with a saved certification in the new CPM 2.0 platform.",
            },
        ],
        tpoReports: [
            {
                title: "Lender Certification Activity",
                body: "All certification data, including lender details and certification status, on any project or phase with a saved certification in the new CPM 2.0 platform.",
            },
        ]
    }
}


export const logoutUrls = {
  external: {
    dev: "https://fmsso-devl.fanniemae.com/idp/startSLO.ping?TargetResource=https://singlefamily.fanniemae.com/applications-technology/condo-project-manager",
    acpt: "https://fmsso-acpt.fanniemae.com/idp/startSLO.ping?TargetResource=https://singlefamily.fanniemae.com/applications-technology/condo-project-manager",
    prod: "https://fmsso.fanniemae.com/idp/startSLO.ping?TargetResource=https://singlefamily.fanniemae.com/applications-technology/condo-project-manager",
  },
  internal: {
    dev: "https://fmsso-devl.fanniemae.com/idp/startSLO.ping?TargetResource=https://singlefamily.fanniemae.com/applications-technology/condo-project-manager",
    acpt: "https://fmsso-acpt.fanniemae.com/idp/startSLO.ping?TargetResource=https://singlefamily.fanniemae.com/applications-technology/condo-project-manager",
    prod: "https://fmsso.fanniemae.com/idp/startSLO.ping?TargetResource=https://singlefamily.fanniemae.com/applications-technology/condo-project-manager",
  },
};

export function getLogoutUrl(userDetails) {
  switch (getEnvName()) {
    case "local":
    case "dev":
      return userDetails?.isInternalUser
        ? logoutUrls.internal.dev
        : logoutUrls.external.dev;
    case "acpt":
      return userDetails?.isInternalUser
        ? logoutUrls.internal.acpt
        : logoutUrls.external.acpt;
    default: 
      return userDetails?.isInternalUser
        ? logoutUrls.internal.prod
        : logoutUrls.external.prod;
  }
};


export function getPSGroupByEnv() {
  let group = 'SG-GFY-LE-CondoGo-ProjStd';
  if (getEnvName() === 'prod') {
    group = 'SG-GFY-PROD-CondoGo-ProjStd';
  } 
  return group;
};

/**
 * @deprecated SDK keys are now fetched at runtime via SdkKeysService.
 * This function is retained only for backward compatibility during rollout.
 * Remove after SDK Keys From Secrets feature is fully deployed.
 */
export function getLaunchDarklyClientId() {
  console.warn('getLaunchDarklyClientId() is deprecated — SDK keys are now fetched from the backend via SdkKeysService.');
  return null;
};

